/* eslint no-underscore-dangle: ["error", { "allow": ["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] }] */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './sass/index.scss';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';
import appReducers from './appReducers';
import Root from './components/Root';
import 'normalize.css';
import * as serviceWorker from './serviceWorker';
import './FontAwesomeIcons';
import sagas from './sagas';

const initialState = {};
const devMode = process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const composeEnhancers = devMode ? (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose) : compose;
const sagaMiddleware = createSagaMiddleware();
const middleware = [
  sagaMiddleware,
  devMode && reduxImmutableStateInvariant(),
];

const store = createStore(
  appReducers,
  initialState,
  composeEnhancers(applyMiddleware(...middleware)),
);

sagaMiddleware.run(sagas);

export default ReactDOM.render(
  <Root store={store} />,
  document.getElementById('root') || document.createElement('div'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
